// ----------------------------------------------------
// src/Routes.jsx
// ----------------------------------------------------

import React from "react";
import AppRoutes from "./Routes/AppRoutes";

const Routes = () => {
  return <AppRoutes />;
};

export default Routes;